import React from 'react';
import { ArrowRightIcon, CoinsIcon, LayoutGridIcon, MapIcon, PuzzleIcon, UsersIcon } from 'lucide-react';
import { Card, CardLabel, Fade, Hi, Slide, SlideHeader } from '../deck/Slide';
import { SLIDE_INDEX } from '../../data/slideIndex';
import { goToSlide } from '../../utils/deckNavigation';
type Topic = {
  id: string;
  icon: typeof CoinsIcon;
  word: string;
  question: string;
  /** Slide this question is answered on. */
  target: number;
  targetLabel: string;
};
const topics: Topic[] = [{
  id: 'budget',
  icon: CoinsIcon,
  word: 'Budget',
  question: 'Budgets for this year are already committed',
  target: SLIDE_INDEX.scaling,
  targetLabel: 'Scaling fairly across local markets'
}, {
  id: 'fit',
  icon: PuzzleIcon,
  word: 'Fit',
  question: 'How does this fit the standardization agenda?',
  target: SLIDE_INDEX.whyWhere,
  targetLabel: 'A new approach to engagement'
}, {
  id: 'stack',
  icon: LayoutGridIcon,
  word: 'Overlap',
  question: 'Do we already own this in our stack?',
  target: SLIDE_INDEX.techStack,
  targetLabel: 'Playing nicely with your tech stack'
}, {
  id: 'manpower',
  icon: UsersIcon,
  word: 'Resourcing',
  question: 'Who does the work, and what about MLR?',
  target: SLIDE_INDEX.controlTower,
  targetLabel: 'Visibility and control, not another project'
}, {
  id: 'markets',
  icon: MapIcon,
  word: 'Fairness',
  question: 'Will smaller markets be penalized later?',
  target: SLIDE_INDEX.pilotOptions,
  targetLabel: 'Flexible pilot options for Q4'
}];
export function ConcernsSlide() {
  return <Slide data-id="element-46" data-mp="krt37hbyqcfz">
      <SlideHeader eyebrow="Before we get to scope" data-id="element-47" data-mp="ko5agkecdu2b">
        Questions worth asking, <Hi data-id="element-48" data-mp="gn3a208ovbyr">and where we land on each.</Hi>
      </SlideHeader>

      <div className="grid min-h-0 flex-1 grid-cols-3 grid-rows-2 gap-[clamp(0.75rem,1.4vw,1.4rem)]" data-id="element-49" data-mp="1w4vkyfpst81q">
        {topics.map((topic, index) => <Fade key={topic.id} delay={0.18 + index * 0.07} className="flex" data-id="element-50" data-mp="1s3jte4nd6cqw" data-mpi={index}>
            <button type="button" onClick={() => goToSlide(SLIDE_INDEX.questions, topic.target)} className="group flex flex-1 flex-col rounded-2xl border border-black/5 bg-[var(--surface)] p-[clamp(1rem,1.6vw,1.6rem)] text-left shadow-sm transition-colors hover:border-[var(--brand-green-light)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand-green)]" data-id="element-51" data-mp="os4c4h536ia1">
              <topic.icon className="h-6 w-6 text-[var(--brand-green-light)]" aria-hidden="true" data-id="element-52" data-mp="60bkor5o154f" />
              <p className="mt-3 text-[clamp(1.4rem,2.4vw,2.4rem)] font-bold leading-none text-[var(--fg)]" data-id="element-53" data-mp="f2ujn06byxle">
                {topic.word}
              </p>
              <p className="mt-2 text-[clamp(0.82rem,1.02vw,1.02rem)] leading-snug text-[var(--muted)]" data-id="element-54" data-mp="jvxd78b3y71l">
                {topic.question}
              </p>
              <span className="mt-auto flex items-start gap-2 pt-3 text-[clamp(0.7rem,0.9vw,0.9rem)] font-bold uppercase tracking-wider text-[var(--brand-green)]" data-id="element-55" data-mp="3nhurg8i579ho">
                <ArrowRightIcon className="mt-px h-4 w-4 flex-shrink-0 transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-56" data-mp="3b0jxtr0h55fk" />
                {topic.targetLabel}
              </span>
            </button>
          </Fade>)}

        <Fade delay={0.6} className="flex" data-id="element-57" data-mp="2x0iy4evy441o">
          <Card className="flex flex-1 flex-col justify-center" data-id="element-58" data-mp="2x1avnv93sbul">
            <CardLabel tone="muted" data-id="element-59" data-mp="2s9anxgmskeng">How to use this page</CardLabel>
            <p className="mt-2 text-[clamp(0.85rem,1.1vw,1.1rem)] leading-relaxed text-[var(--muted)]" data-id="element-60" data-mp="2s7pwhzvrxbtt">
              Each question jumps straight to the slide that answers it, so we
              only go there if the room wants to.
            </p>
          </Card>
        </Fade>
      </div>
    </Slide>;
}